import React from 'react';
import sample from 'lodash/sample';
import { getLatestScenes } from '../../actions/search';
import { MARKETING_NAV_LINKS } from '../../constants';
import Layout from '../../components/Layout';
import HowItWorks from './HowItWorks';

async function action(context) {
  await context.store.dispatch(getLatestScenes());

  return {
    chunks: ['marketing'],
    title: 'How It Works - Storytape',
    description:
      'Instead of paying $200-$500 for a single clip, Storytape gives you access to thousands of cinematic 4K stock footage files on a single monthly subscription.',
    component: (
      <Layout
        transitionId="how-it-works"
        showHeader={true}
        headerNavLinks={MARKETING_NAV_LINKS}
      >
        <HowItWorks />
      </Layout>
    ),
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/howItWorks/index.js